import { Tooltip, IconButton } from "@mui/material";
import { Refresh } from "@mui/icons-material";

export interface CustomToolbarReloadComponentProps {
    title: string;
    onClickAction: () => void;
}

export const CustomToolbarReloadComponent = ({ title, onClickAction }: CustomToolbarReloadComponentProps) => {
    return (
        <>
            <Tooltip title={title}>
                <IconButton onClick={onClickAction} >
                    <Refresh />
                </IconButton>
            </Tooltip>
        </>
    );
};
